/**
 * @file: ClientIdMiddleware.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { Middleware } from '@euler/lib/request/Middleware';
import { RequestContext } from '@euler/lib/request/types';
import { clientPlatform } from '@euler/services/clientPlatform';
import { getCommonRequestParameters } from '@euler/services/utils';

export class ClientInfoMiddleware implements Middleware {
  async pre(context: RequestContext): Promise<void> {
    const {
      appId,
      clientId,
      clientVersion,
      clientVersionCode,
      nonce,
      timestamp,
      digest,
    } = await getCommonRequestParameters();
    context.init.headers = {
      ...context.init.headers,
      ['X-Client-Id']: clientId,
      ['X-Client-Version']: clientVersion,
      ['X-Client-Version-Code']: String(clientVersionCode),
      ['X-Client-AppId']: appId,
      ['X-Client-Platform']: clientPlatform(),
      ['X-Request-Nonce']: nonce,
      ['X-Request-Timestamp']: String(timestamp),
      ['X-Request-Digest']: digest,
    };
  }
}
